import { Component, OnInit, Input, EventEmitter, Output,  } from '@angular/core';
import { DisplayItem } from '../../../../lib/display/display-item/display-item';

@Component({
  selector: 'app-display-item-receipt-switcher',
  templateUrl: './receipt-switcher.component.html',
  styleUrls: ['./receipt-switcher.component.css']
})
export class DisplayItemReceiptSwitcherComponent implements OnInit {
  @Input()
  displayItem: DisplayItem;

  @Output()
  onClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
  ) {

  }

  ngOnInit() {
  }

}
